import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import App from './App'
import configureErrorReporting from './lib/errors/configureErrorReporting'

configureErrorReporting()
ReactDOM.render(<App />, document.getElementById('root'))
